import React, { useState, useEffect } from 'react';
import '../Dropdown/Dropdown.css';
import LoadingOverlay from '../components/LoadingOverlay';
import { getAuthToken } from '../utils/auth';
import BASE_URL from '../utils/api';

export default function AutorizarNotaEmMassa() {
  const [notasPendentes, setNotasPendentes] = useState([]);
  const [notasSelecionadas, setNotasSelecionadas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [resultados, setResultados] = useState([]);
  const [erro, setErro] = useState('');
  const [mostrarResultados, setMostrarResultados] = useState(false);

  useEffect(() => {
    carregarNotasPendentes();
  }, []);

  const apiCall = async (endpoint, options = {}) => {
    const urls = [
      `${BASE_URL}/${endpoint}`,
      `${BASE_URL}/${endpoint}`,
      `${BASE_URL}/${endpoint}`,
      `${BASE_URL}/${endpoint}`,
      `${BASE_URL}/${endpoint}`
    ];

    for (const url of urls) {
      try {
        console.log(`Tentando conectar em: ${url}`);
        const token = getAuthToken();
        const optionsWithAuth = { ...options, headers: { ...(options.headers || {})} };
        if (token) optionsWithAuth.headers['Authorization'] = 'Bearer ' + token;
        const response = await fetch(url, optionsWithAuth);
        if (response.ok) {
          console.log(`✅ Sucesso em: ${url}`);
          return await response.json();
        }
        const errorText = await response.text();
        console.log(`❌ Falha em: ${url} - Status: ${response.status} - ${errorText}`);
        if (url === urls[urls.length - 1]) {
          throw new Error(errorText || `Erro HTTP ${response.status}`);
        }
      } catch (error) {
        console.log(`❌ Erro em: ${url} - ${error.message}`);
        if (url === urls[urls.length - 1]) {
          throw error;
        }
      }
    }
  };

  const carregarNotasPendentes = async () => {
    try {
      setLoading(true);
      setErro('');
      const data = await apiCall('NotaFiscal/pendentes');
      const lista = Array.isArray(data) ? data : [];
      setNotasPendentes(lista);
    } catch (err) {
      console.error('Erro ao carregar notas pendentes:', err);
      setErro('Erro ao carregar notas pendentes. Verifique se o backend está rodando.');
    } finally {
      setLoading(false);
    }
  };

  const toggleNotaSelecionada = (notaId) => {
    setNotasSelecionadas(prev => {
      if (prev.includes(notaId)) {
        return prev.filter(id => id !== notaId);
      } else {
        return [...prev, notaId];
      }
    });
  };

  const toggleSelecionarTodas = () => {
    if (notasSelecionadas.length === notasPendentes.length) {
      setNotasSelecionadas([]);
    } else {
      const todasIds = notasPendentes.map(n => n.id || n.Id || n.notaId);
      setNotasSelecionadas(todasIds);
    }
  };

  const handleAutorizarEmMassa = async (e) => {
    e.preventDefault();
    
    if (notasSelecionadas.length === 0) {
      setErro('Selecione pelo menos uma nota fiscal para autorizar.');
      return;
    }

    try {
      setLoading(true);
      setErro('');
      setResultados([]);
      setMostrarResultados(false);

      const resultado = await apiCall('NotaFiscal/autorizar-em-massa', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(notasSelecionadas)
      });

      setResultados(Array.isArray(resultado) ? resultado : []);
      setMostrarResultados(true);
      setNotasSelecionadas([]);
      
      // Recarregar lista após 2 segundos
      setTimeout(() => {
        carregarNotasPendentes();
      }, 2000);
    } catch (err) {
      console.error('Erro ao autorizar notas em massa:', err);
      setErro(`Erro ao autorizar: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const sucessos = resultados.filter(r => r.sucesso || r.success).length;
  const falhas = resultados.length - sucessos;

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f0f0f0', 
      padding: '40px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <div style={{ 
        width: '100%', 
        maxWidth: '1000px',
        background: 'white',
        borderRadius: '12px',
        padding: '40px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ 
          color: 'rgb(235, 133, 0)', 
          fontSize: '28px', 
          fontWeight: 'bold',
          marginBottom: '10px',
          textAlign: 'center'
        }}>
          Autorizar Notas Fiscais - Em Massa
        </h1>
        
        <p style={{ 
          textAlign: 'center', 
          color: '#666', 
          marginBottom: '30px',
          fontSize: '14px'
        }}>
          Selecione múltiplas notas fiscais pendentes para autorizar no SEFAZ de uma só vez
        </p>

        {erro && (
          <div style={{
            background: '#ffebee',
            color: '#c62828',
            padding: '15px',
            borderRadius: '8px',
            marginBottom: '20px',
            border: '1px solid #ef5350'
          }}>
            {erro}
          </div>
        )}

        {mostrarResultados && resultados.length > 0 && (
          <div style={{
            background: '#f5f5f5',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '20px',
            border: '1px solid #ddd'
          }}>
            <h3 style={{ 
              marginTop: 0, 
              marginBottom: '15px',
              color: '#333',
              fontSize: '18px'
            }}>
              Resultados da Autorização:
            </h3>
            <div style={{ 
              display: 'flex', 
              gap: '20px', 
              marginBottom: '15px',
              fontSize: '15px'
            }}>
              <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                ✅ Sucessos: {sucessos}
              </span>
              <span style={{ color: '#c62828', fontWeight: 'bold' }}>
                ❌ Falhas: {falhas}
              </span>
            </div>
            <div style={{ 
              maxHeight: '300px', 
              overflowY: 'auto',
              background: 'white',
              borderRadius: '6px',
              padding: '10px'
            }}>
              {resultados.map((res, index) => (
                <div 
                  key={index}
                  style={{
                    padding: '10px',
                    marginBottom: '8px',
                    borderRadius: '6px',
                    background: res.sucesso || res.success ? '#e8f5e9' : '#ffebee',
                    border: `1px solid ${res.sucesso || res.success ? '#66bb6a' : '#ef5350'}`
                  }}
                >
                  <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                    {res.sucesso || res.success ? '✅' : '❌'} Nota Fiscal ID: {res.nfId || res.id}
                  </div>
                  {res.notaFiscal && (
                    <div style={{ fontSize: '13px', color: '#2e7d32' }}>
                      NF #{res.notaFiscal.numero || res.notaFiscal.Numero} - 
                      Status: {res.notaFiscal.status || res.notaFiscal.Status}
                    </div>
                  )}
                  {res.mensagem && (
                    <div style={{ 
                      fontSize: '13px', 
                      color: res.sucesso || res.success ? '#2e7d32' : '#c62828',
                      marginTop: '5px'
                    }}>
                      {res.mensagem}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        <form onSubmit={handleAutorizarEmMassa}>
          <div style={{ marginBottom: '25px' }}>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              marginBottom: '15px'
            }}>
              <label style={{ 
                color: '#333',
                fontWeight: '500',
                fontSize: '16px'
              }}>
                Notas Fiscais Pendentes ({notasSelecionadas.length} selecionadas):
              </label>
              
              {notasPendentes.length > 0 && (
                <button
                  type="button"
                  onClick={toggleSelecionarTodas}
                  style={{
                    padding: '8px 16px',
                    fontSize: '14px',
                    border: '1px solid rgb(235, 133, 0)',
                    borderRadius: '6px',
                    background: 'white',
                    color: 'rgb(235, 133, 0)',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgb(235, 133, 0)';
                    e.target.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'white';
                    e.target.style.color = 'rgb(235, 133, 0)';
                  }}
                >
                  {notasSelecionadas.length === notasPendentes.length ? 'Desmarcar Todas' : 'Selecionar Todas'}
                </button>
              )}
            </div>

            <div style={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              maxHeight: '400px',
              overflowY: 'auto',
              background: '#fafafa'
            }}>
              {notasPendentes.length === 0 && !loading ? (
                <div style={{ 
                  padding: '40px', 
                  textAlign: 'center', 
                  color: '#666',
                  fontSize: '15px'
                }}>
                  Nenhuma nota fiscal pendente de autorização.
                </div>
              ) : (
                notasPendentes.map((nota) => {
                  const id = nota.id || nota.Id || nota.notaId;
                  const numero = nota.numero || nota.Numero || '';
                  const nomeCliente = nota.nomeCliente || nota.NomeCliente || nota.Cliente?.Nome || '';
                  const valor = nota.valor || nota.Valor || nota.valorTotal || nota.ValorTotal || 0;
                  const dataEmissao = nota.dataEmissao || nota.DataEmissao || '';
                  const selecionada = notasSelecionadas.includes(id);
                  
                  return (
                    <div 
                      key={id}
                      onClick={() => toggleNotaSelecionada(id)}
                      style={{
                        padding: '15px',
                        borderBottom: '1px solid #ddd',
                        cursor: 'pointer',
                        background: selecionada ? '#fff3e0' : 'white',
                        transition: 'all 0.2s',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '15px'
                      }}
                      onMouseEnter={(e) => {
                        if (!selecionada) e.currentTarget.style.background = '#f5f5f5';
                      }}
                      onMouseLeave={(e) => {
                        if (!selecionada) e.currentTarget.style.background = 'white';
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={selecionada}
                        onChange={() => {}}
                        style={{
                          width: '18px',
                          height: '18px',
                          cursor: 'pointer'
                        }}
                      />
                      <div style={{ flex: 1 }}>
                        <div style={{ 
                          fontWeight: 'bold', 
                          marginBottom: '5px',
                          fontSize: '15px',
                          color: '#333'
                        }}>
                          NF #{numero} - {nomeCliente}
                        </div>
                        <div style={{ 
                          fontSize: '13px', 
                          color: '#666',
                          display: 'flex',
                          gap: '20px'
                        }}>
                          <span>Valor: R$ {Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                          {dataEmissao && (
                            <span>Emissão: {new Date(dataEmissao).toLocaleDateString('pt-BR')}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>

          <div style={{ 
            display: 'flex', 
            gap: '15px', 
            justifyContent: 'flex-end',
            marginTop: '30px'
          }}>
            <button
              type="button"
              onClick={() => window.history.back()}
              style={{
                padding: '12px 30px',
                fontSize: '15px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                background: 'white',
                color: '#666',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.background = '#f5f5f5'}
              onMouseLeave={(e) => e.target.style.background = 'white'}
            >
              Voltar
            </button>
            
            <button
              type="submit"
              disabled={notasSelecionadas.length === 0 || loading}
              style={{
                padding: '12px 30px',
                fontSize: '15px',
                border: 'none',
                borderRadius: '6px',
                background: notasSelecionadas.length > 0 && !loading ? 'rgb(235, 133, 0)' : '#ccc',
                color: 'white',
                cursor: notasSelecionadas.length > 0 && !loading ? 'pointer' : 'not-allowed',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                if (notasSelecionadas.length > 0 && !loading) {
                  e.target.style.background = 'rgb(208, 116, 0)';
                }
              }}
              onMouseLeave={(e) => {
                if (notasSelecionadas.length > 0 && !loading) {
                  e.target.style.background = 'rgb(235, 133, 0)';
                }
              }}
            >
              {loading ? 'Autorizando...' : `Autorizar ${notasSelecionadas.length} Nota(s)`}
            </button>
          </div>
        </form>
      </div>

      <LoadingOverlay isLoading={loading} message="Autorizando notas fiscais..." />
    </div>
  );
}
